import axios from "axios";
import { ONLINE_API } from "../config";
import { getAppCheckToken } from "../services/appCheck";
import { AUTH } from "../auth/FirebaseContext";

const customOnlineAxios = axios.create({
    baseURL: ONLINE_API,
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: false,
});

customOnlineAxios.interceptors.request.use(
    async (config) => {
        const appCheckToken = await getAppCheckToken();
        if (appCheckToken) {
            config.headers["X-Firebase-AppCheck"] = appCheckToken;
        }
        // Potpisan identitet kupca — /status gard proverava vlasnika prodaje.
        const user = AUTH.currentUser;
        if (user) {
            config.headers.Authorization = `Bearer ${await user.getIdToken()}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

customOnlineAxios.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (axios.isCancel(error) || error?.code === "ERR_CANCELED") {
            return Promise.reject(error);
        }
        return Promise.reject((error.response && error.response.data) || error);
    }
);

// idempotencyKey se generiše u BookingPage.js (useState + crypto.randomUUID)
// i prosledjuje ovde kroz payload. Ako postoji, backend dedup-uje pri retry-u.
export const onlineReserve = async (payload) => {
    const { data } = await customOnlineAxios.post("/reserve", payload);
    return data;
};

export const onlinePaymentSession = async (payload) => {
    const { data } = await customOnlineAxios.post("/payment-session", payload);
    return data;
};

export const onlineFinalize = async (payload) => {
    const { data } = await customOnlineAxios.post("/finalize", payload);
    return data;
};

export const onlineRelease = async (payload) => {
    const { data } = await customOnlineAxios.post("/release", payload);
    return data;
};

export const onlineStatus = async (merchantPaymentId) => {
    const { data } = await customOnlineAxios.get(`/status/${merchantPaymentId}`);
    return data;
};

export default customOnlineAxios;
